import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Modal, Paper,
    List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction,
    Typography, Divider, LinearProgress
} from '@mui/material';

import Icon from '@mdi/react'
import {
    mdiRoadVariant,
} from '@mdi/js';


import { liveTrackinglayoutSelector, setlayoutLiveTracking } from '../../features/layout/layoutSlice';
import { getKilometersOneAsset, selectVehicleById } from '../../features/assets/assetsSlice';
import { distancePeriodNames, getperiod } from '../../utils/datePeriodCalculator';

const AssetKilometersModal = ({ distanceOpen, handleDistanceClose, assetId }) => {
    const dimention = useSelector(liveTrackinglayoutSelector);
    const dispatch = useDispatch();
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const distanceMatrix = assetData && assetData.distanceMatrix;
    const regn = assetData && assetData.vehicleDevice.regn;

    //console.log("distanceMatr", assetId, distanceMatrix);
    useEffect(() => {
        //console.log("useEffect distanceMatrix", assetId, distanceMatrix);
        if (typeof (distanceMatrix) === 'string' && distanceOpen) {
            //console.log("Lets get distanceMatrix", typeof (distanceMatrix), distanceOpen);
            dispatch(getKilometersOneAsset({
                assetId
            }));
        }
    }, [assetId, distanceOpen, dispatch, distanceMatrix])

    useEffect(() => {
        const liveTrackingLayoutPayload = {
            mapModalHeight: 750,
        };
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
        return () => {
            const liveTrackingLayoutPayload = {
                mapModalHeight: 500
            };
            dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
        }
    }, [dispatch])

    return (

        <Modal
            open={distanceOpen}
            onClose={handleDistanceClose}
        >
            <div style={dimention.mapModal}>
                <Paper>
                    {
                        distanceMatrix === 'loading' || distanceMatrix === 'none' ?
                            <Fragment>
                                <LinearProgress />
                                <LinearProgress color="secondary" />
                            </Fragment>
                            :
                            distanceMatrix &&
                            <List dense>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography variant="h6"><b>Kilometers: {regn}</b></Typography>
                                        }
                                    />
                                </ListItem>
                                <Divider />
                                {
                                    Object.keys(distanceMatrix).map(dM => (
                                        <ListItem key={dM}>
                                            <ListItemIcon>
                                                <Icon path={mdiRoadVariant} size={1} color="DodgerBlue" />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body1"><b>{distancePeriodNames[dM]}</b></Typography>
                                                }
                                                secondary={
                                                    <Fragment>
                                                        <Typography variant="subtitle2">
                                                            {`From: ${getperiod(dM).fromDate.format('D MMM YY h:mm A')}`}
                                                        </Typography>
                                                        <Typography variant="subtitle2">
                                                            {`To  : ${getperiod(dM).toDate.format('D MMM YY h:mm A')}`}
                                                        </Typography>
                                                    </Fragment>
                                                }
                                            />
                                            <ListItemSecondaryAction>
                                                <Typography variant="body1">
                                                    <b>{`${distanceMatrix[dM]} Km`}</b>
                                                </Typography>

                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }
                            </List>

                    }

                </Paper>
            </div>
        </Modal>

    );
}

export default React.memo(AssetKilometersModal);

/*
<Fragment>
<Typography variant="body1">
{`From: ${getperiod(dM).fromDate.format('D-M-YY h:mm A')}`}
</Typography>
<Typography variant="body1">
{`To: ${getperiod(dM).toDate.format('D-M-YY h:mm A')}`}
</Typography>
</Fragment>
*/